import QrcodeModal from '../../components/qrcodeModal';
function showQrcode() {
  new QrcodeModal({
    wrapper: this.$container.get(0),
    closeBtn: false,
    configShare: this.params.configShare,
  });
}

export default {
  showQrcode,
};
